// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tg","play":"ug"};